import partial from 'lodash/partial'
import React from 'react'
import {Link} from 'react-router-dom'

import * as track from '../../../track/product'
import * as URLS from '../../../urls'

import LinkedSection from '../../LinkedSection'
import Svg from '../../Svg'

import fitGuarantee from '../../../../../svg/fit-guarantee.svg'

const trackLinkClick = partial(track.pdpClicked, 'Fit Guarantee Learn More', URLS.FIT_GUARANTEE)

const FitGuaranteeBanner = () => (
  <LinkedSection
    className="pdp-section c-fit-guarantee-banner"
    to={URLS.FIT_GUARANTEE}
    onClick={() => trackLinkClick()}
  >
    <div className="o-media c-fit-guarantee-banner__inner">
      <Svg
        className="o-media__figure c-fit-guarantee-banner__figure"
        src={fitGuarantee}
        Tag="figure"
        role="presentation"
      />
      <div className="o-media__body">
        <h2 className="c-fit-guarantee-banner__title">Our Fit Guarantee</h2>
        <p className="c-fit-guarantee-banner__subtitle">
          Free shipping, free returns, free replacements.
        </p>
        <Link
          className="c-fit-guarantee-banner__link"
          to={URLS.FIT_GUARANTEE}
          onClick={() => trackLinkClick()}
        >
          Learn More &#x2192;
        </Link>
      </div>
    </div>
  </LinkedSection>
)

export default FitGuaranteeBanner
